import api from "@/api/api";

// Матч сыгран, если в нём уже назначен победитель
const isMatchFinished = (match) => (match.teams || []).some((team) => team?.result_fields?.is_winner === 1)

/**
 * Освобождает ячейки MLBB-сетки, которые занимает команда.
 *
 * Снятие команды с этапа или турнира не трогает сетку: команда так и
 * остаётся стоять в матче, хотя играть уже не будет. Поэтому после снятия
 * проходим по сеткам этапов и убираем её из ещё не сыгранных матчей.
 * Сыгранные матчи не трогаем — это история, по которой уже прошло
 * продвижение по сетке.
 *
 * Этапы без сгенерированной сетки пропускаются молча.
 *
 * @param {Object} params
 * @param {number[]} params.stageIds — этапы, в сетках которых искать команду
 * @param {number} params.teamId — id команды (не stage_team / tournament_team)
 * @returns {Promise<{cleared: number, failed: number}>}
 */
export const clearTeamFromMlbbGrid = async ({ stageIds, teamId }) => {
    if (!teamId || !stageIds?.length) return { cleared: 0, failed: 0 }

    const gridResponses = await Promise.allSettled(stageIds.map((stageId) => api.grid.getGrid(stageId)))

    const groupIds = new Set()
    gridResponses.forEach((response) => {
        if (response.status !== 'fulfilled') return
        const grids = response.value?.data?.data?.grids || []
        grids.forEach((grid) => {
            (grid?.matches || []).forEach((match) => {
                const hasTeam = (match.teams || []).some(({ id }) => id === teamId)
                if (hasTeam && match.group_id && !isMatchFinished(match)) groupIds.add(match.group_id)
            })
        })
    })

    const results = await Promise.allSettled(
        [...groupIds].map((groupId) => api.grid.deleteTeamFromGroup(groupId, teamId))
    )

    return {
        cleared: results.filter(({ status }) => status === 'fulfilled').length,
        failed: results.filter(({ status }) => status === 'rejected').length,
    }
}
